import qs from 'qs';
import { config as envConfig } from 'ENV_CONFIG';
import { services } from '~/ocab-services/services.constant';

const getFromQueryParam = () => qs.parse(window.location.search, { ignoreQueryPrefix: true }).appointmentTypeId;

export const getAppointmentsDetails = (appointmentType) => {
  const appointmentTypeId = appointmentType.id ? appointmentType.id : getFromQueryParam();
  const journey = envConfig.services[services.MEASURE.name].appointmentTypes[appointmentTypeId]?.analyticsJourneyName;
  const products = window.jlData?.page?.appointments?.products || [];
  return ({
    journey,
    branchId: '',
    products,
  });
};

export const getAnalyticsData = ({ products }) => ({
  products: products ?? window.jlData?.page?.appointments?.products ?? [],
});
